export default __webpack_public_path__ + "static/media/6036-min.c7d682fe.jpg";